// once MAO is part of super listing, we can move this file into listing folder
import { OfferingForm } from '@/buyer-portal/components/features/offerings/OfferingDetailsLayout/OfferingForm/OfferingForm'

import { OfferingStatusBanner } from './OfferingStatusBanner'
import type { MakeAnOfferModel } from './useMakeAnOfferModel'

export const MakeAnOfferContent = ({ model }: { model: MakeAnOfferModel }) => {
  const {
    contract,
    currency,
    isIndexed,
    items,
    offers,
    offering,
    selectedQuote,
    status,
  } = model

  return (
    // oxlint-disable-next-line react/refs
    <div ref={model.ref}>
      <OfferingStatusBanner
        offering={offering}
        offers={offers}
        contract={contract}
        isListingIndexed={isIndexed}
        status={status}
      />
      <OfferingForm
        contract={contract}
        currency={currency}
        offeringItems={items}
        offering={offering}
        offers={offers}
        selectedQuote={selectedQuote}
      />
    </div>
  )
}
